import moment from '@/assets/setups/moment'
import { CV_BANK_CODES } from '@/assets/constants/accounts'

/* eslint-disable */
export const emailValidator = (email) => {
	let regex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
	return regex.test(email)
}

export const phoneNumberValidator = (phoneNumber) => {
	return phoneNumber.length >= 7 && phoneNumber.length <= 17
}

export const baiPhoneNumberValidator = (phoneNumber) => {
	return phoneNumber.length >= 7 && phoneNumber.length <= 17
}

export const naHoraPhoneNumberValidator = (phoneNumber) => {
	return phoneNumber.length === 9 || phoneNumber.length === 13 || phoneNumber.length === 14
}

export const internationalPhoneNumberValidator = (phoneNumber) => {
	/*	Mdw accepts 9-24 digits for regular phone numbers or phone numbers starting with +
		But only accepts 9-22 digits if phone number starts with 00
	*/
	let regex = /^(00\d{9,22}|\+\d{9,24}|\d{9,24})$/
	return regex.test(phoneNumber)

}

export const isValidDate = date => {
  return moment(date).isValid()
}

/* Compared in UTC on purpose: the group header prints the date with moment.utc, so the
Hoje/Ontem prefix has to be decided in the same frame or the two disagree (issue #117684) */
export const isToday = date => moment.utc(date).isSame(moment.utc(), 'day')

export const isYesterday = date => moment.utc(date).isSame(moment.utc().subtract(1, 'days'), 'day')

export const removeAccents = strAccents => {
    var strAccents = strAccents.split('');
    var strAccentsOut = new Array();
    var strAccentsLen = strAccents.length;
    var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
    for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
            strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else
            strAccentsOut[y] = strAccents[y];
    }
    strAccentsOut = strAccentsOut.join('');
    return strAccentsOut;
}

export const noSpecialChar = string => {
	let regex = /^[a-zA-Z0-9 ]*$/
	return regex.test(string)
}

export const noSpecialCharNoSpace = string => {
	let regex = /^[a-zA-Z0-9]*$/
	return regex.test(string)
}

export const noSpecialCharNoSpaceExceptAtAndDot = string => {
	let regex = /^[a-zA-Z0-9@.]*$/
	return regex.test(string)
}

export const withAccentsButNoSpecialChars = string => {
	let regex = /^[A-zÀ-ú0-9 ]*$/
	return regex.test(string)
}

export const noSpecialCharAlphabetical = string => {
	let regex = /^[a-zA-Z ]*$/
	return regex.test(string)
}

export const onlyNumbersChars = string => {
	let regex = /^[0-9 ]*$/
	return regex.test(string)
}

export const onlyLettersNoSpace = string => {
	let regex = /^[a-zA-Z]*$/
	return regex.test(string)
}

export const onlyNumbersNoSpace = string => {
	let regex = /^[0-9]*$/
	return regex.test(string)
}

export const numbersWithHifen = string => {
	let regex = /^[0-9-]*$/
	return regex.test(string)
}

export const postalCode = string => {
	let regex = /^[0-9 -]*$/
	return regex.test(string)
}

export const noSpecialCharTransfers = string => {
	let regex = /^[a-zA-Z0-9 .(+)-/,?:']*$/
	return regex.test(string)
}

export const percentageValidator = (string, maxPercentageValue) => {
	return string > 0 && string <= maxPercentageValue
}

export const isMobileValidator = () => {
	return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)))
}

export const isWebSmallWindow = () => {
    return window.innerWidth < 880
}

export const isValidCvNibBankCode = nib => {
    const digits = nib.replace(/\s+/g, '')
    return CV_BANK_CODES.includes(digits.slice(0, 4))
}

export const checkIfOperationHasNegativeAmount = (operationTypeId) => {
	let negativeAmount

	/* this operationTypes need to have positiveAmounts, all the rest has negative amounts even if mdw sends positive value */
	switch (operationTypeId) {
	case 32003: /* Request/Receive NaHora Transfer */
	case 44: /* Mobalize DPs */
		negativeAmount = false
		break

	default:
		negativeAmount = true
		break
	}

	return negativeAmount
}

/* Beneficiary destination - #118851
Accepts an account number (15 digits), a NIB (21 digits) or any IBAN (CV or foreign).
IBAN range follows what international transfers already use: 15 to 34 alphanumeric chars. */
export const beneficiaryDestinationValidator = destination => {
    const rawDestination = destination.replace(/\s+/g, '').toUpperCase()

    if (!rawDestination.length) return true
    if (onlyNumbersChars(rawDestination)) return rawDestination.length === 15 || rawDestination.length === 21

    return /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(rawDestination)
}

/* Returns the i18n key suffix for the message that matches what was typed - #118851 */
export const beneficiaryDestinationErrorKey = destination => {
    const rawDestination = destination.replace(/\s+/g, '').toUpperCase()

    if (!onlyNumbersChars(rawDestination)) return 'genericDestinationErrorMessageIBAN'
    if (rawDestination.length < 15) return 'genericDestinationErrorMessageAccount'

    return 'genericDestinationErrorMessageNIB'
}
